// app/auth/components/ConditionalAuthProvider.tsx

"use client";

import { usePathname } from "next/navigation";

import { AuthProvider } from "./authProvider";
import { AuthRecoveryRedirect } from "./AuthRecoveryRedirect";

// Routes that need auth functionality
const authRoutes = [
  "/dashboard",
  "/profile",
  "/settings",
  "/onboarding",
  "/admin",
  "/auth",
  "/login",
  "/reset-password",
];

// Check if current path needs auth
function needsAuth(pathname: string): boolean {
  return authRoutes.some(
    (route) => pathname === route || pathname.startsWith(route + "/"),
  );
}

export function ConditionalAuthProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();
  const shouldLoadAuth = needsAuth(pathname);

  // Always mount recovery redirect so Site-URL fallback hashes still work
  // on marketing pages (home, etc.).
  if (shouldLoadAuth) {
    return (
      <>
        <AuthRecoveryRedirect />
        <AuthProvider>{children}</AuthProvider>
      </>
    );
  }

  return (
    <>
      <AuthRecoveryRedirect />
      {children}
    </>
  );
}
